import ResponseError from "#/types/responseError"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import { carrotClient } from "#/utils/CarrotClient"
import { useMutation, UseMutationResult } from "@tanstack/react-query"

export interface PreAuthPayload {
  preAuthAnswersId: number
}

export interface PreAuthResponse {
  coveredSwipeAmount: number
  memberOOPAmount: number
  currencyCode: string
  expirationDate: string
}

export function useCreatePreAuth(): UseMutationResult<PreAuthResponse, ResponseError, PreAuthPayload> {
  return useMutation<PreAuthResponse, ResponseError, PreAuthPayload>(
    (payload: PreAuthPayload) => {
      return carrotClient.createPreAuth(payload)
    },
    {
      retry: buildCarrotApiRetryPolicy(2)
    }
  )
}
